import {Pipe, PipeTransform, inject} from '@angular/core';
import {RichTextSanitizerService} from '../services/rich-text-sanitizer.service';

@Pipe({
  name: 'richTextPlain',
  standalone: true
})
export class RichTextPlainPipe implements PipeTransform {
  private readonly richTextSanitizer: RichTextSanitizerService = inject(RichTextSanitizerService);

  public transform(value: string | null | undefined): string {
    return this.richTextSanitizer.toPlainText(value ?? '');
  }
}
